import {createSlice} from "@reduxjs/toolkit";
import {fetchVideosInfo} from "./action";


const initialState = {
    items: [],
    loadingStatus: 'loaded',
}

const videosSlice = createSlice({
    name: 'videosInfo',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchVideosInfo.pending, state => {
                state.loadingStatus = 'loading'
            })
            .addCase(fetchVideosInfo.fulfilled, (state, action) => {
                state.loadingStatus = 'loaded';
                state.items = action.payload;
            })
            .addCase(fetchVideosInfo.rejected, state => {
                state.loadingStatus = 'error';
            });
    }
});

export const {reducer} = videosSlice;

export default reducer;
